import { gsap } from "./gsap";

export function createFadeUp(target: gsap.TweenTarget, trigger: gsap.DOMTarget, vars: gsap.TweenVars = {}): void {
  gsap.from(target, {
    opacity: 0,
    y: 44,
    duration: 0.9,
    scrollTrigger: { trigger, start: "top 85%" },
    ...vars,
  });
}

export function createStaggerReveal(targets: gsap.TweenTarget, trigger: gsap.DOMTarget, vars: gsap.TweenVars = {}): void {
  gsap.from(targets, {
    opacity: 0,
    y: 44,
    duration: 0.8,
    stagger: 0.09,
    scrollTrigger: { trigger, start: "top 85%" },
    ...vars,
  });
}
